import { render, staticRenderFns } from "./bingWorkPlate.vue?vue&type=template&id=7bd5fcd2&scoped=true&"
import script from "./bingWorkPlate.vue?vue&type=script&lang=js&"
export * from "./bingWorkPlate.vue?vue&type=script&lang=js&"
import style0 from "./bingWorkPlate.vue?vue&type=style&index=0&id=7bd5fcd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd5fcd2",
  null
  
)

export default component.exports